import { render, staticRenderFns } from "./DrcDialog.vue?vue&type=template&id=16eee4db&scoped=true"
import script from "./DrcDialog.vue?vue&type=script&lang=js"
export * from "./DrcDialog.vue?vue&type=script&lang=js"
import style0 from "./DrcDialog.vue?vue&type=style&index=0&id=16eee4db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eee4db",
  null
  
)

export default component.exports